module.exports = __webpack_public_path__ + "static/media/upload-csv.1d91dfc1.png";